<div class="main-loading" *ngIf="loader">
  <img class="loader-img" src="assets/images/loaderspsoft.svg" alt="Loader" />
</div>
